import { evidenceItems } from '@/mocks/homeData';
import { useToast } from '@/hooks/useToast';

const strengthStyle: Record<string, string> = {
  强: 'bg-primary-500 text-background-50',
  中: 'bg-accent-500 text-accent-950',
  弱: 'bg-secondary-200 text-secondary-900',
};

export default function EvidenceSection() {
  const { show, node } = useToast();

  return (
    <section id="evidence" className="px-4 md:px-8 pt-16 md:pt-28">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs tracking-[0.25em] text-primary-600">证据链梳理</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              每条结论都标出出处
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              证据按可信度分级标注，强证据可交叉验证，弱证据仅作参考，不做确定性结论。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            {(['强', '中', '弱'] as const).map((level) => (
              <span key={level} className="flex items-center gap-2 text-xs text-foreground-600">
                <span className={`px-2 py-0.5 rounded-md text-[11px] ${strengthStyle[level]}`}>
                  {level}
                </span>
                {level === '强' ? '可交叉验证' : level === '中' ? '待补充' : '仅作参考'}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-5">
          {evidenceItems.map((item) => (
            <div
              key={item.code}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-sm font-bold tracking-wide text-foreground-900">
                  {item.code}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-md text-[11px] font-medium ${strengthStyle[item.strength]}`}
                >
                  {item.strength}证据
                </span>
              </div>
              <h3 className="mt-4 text-sm font-medium leading-snug text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">
                {item.desc}
              </p>
              <div className="mt-4 pt-4 border-t border-background-200 flex items-center gap-2 text-[11px] text-foreground-500">
                <i className="ri-link w-3.5 h-3.5 flex items-center justify-center" />
                {item.source}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 rounded-lg border border-background-200 bg-secondary-50 px-5 py-5 md:px-8">
          <span className="flex items-start gap-3 text-sm text-foreground-700">
            <i className="ri-information-line w-5 h-5 mt-0.5 flex items-center justify-center text-secondary-700" />
            发现梳理口径有误？把出处和时间点一并发来，我们会在下一版更新中核对。
          </span>
          <button
            type="button"
            onClick={() => show('纠错入口为演示模式，暂不接收提交')}
            className="flex items-center gap-2 px-4 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm whitespace-nowrap transition-colors cursor-pointer hover:bg-secondary-600"
          >
            <i className="ri-edit-line w-4 h-4 flex items-center justify-center" />
            提交纠错
          </button>
        </div>
      </div>
      {node}
    </section>
  );
}